import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'
import { createGlobalStyle } from 'styled-components'
import { Box, Toaster } from '@/components/lib'
import api from '../api'
import useStore from '../store'
import utils from '../utils/utils'

import NavBar from './includes/NavBar'
import Footer from './includes/Footer'
import EntryContainer from './includes/EntryContainer'
import SetupMfa from './security/SetupMfa'

const GlobalStyle = createGlobalStyle`
  body {
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  }
`
export default function App () {
  const location = useLocation()
  const loadSettingsFromStorage = useStore(s => s.loadSettingsFromStorage)
  const completeLogin = useStore(s => s.completeLogin)
  const setTeam = useStore(s => s.setTeam)
  const loadingUser = useStore(s => s.loadingUser)
  const user = useStore(s => s.user)
  const team = useStore(s => s.team)
  const listTrialsIncludeArchived = useStore(s => s.listTrialsIncludeArchived)
  const setTrials = useStore(s => s.setTrials)
  const setLoadingTrials = useStore(s => s.setLoadingTrials)
  // An account that still has to set up two-factor authentication sees only
  // the enrolment screen, and nothing below fetches on its behalf: the API
  // refuses its session everything but the set-up routes.
  const mfaEnrolRequired = !!user?.mfaEnrolRequired
  const teamId = mfaEnrolRequired ? null : user?.team

  useEffect(() => {
    api.accounts.autoLogin(token => completeLogin(token))
    loadSettingsFromStorage()
  }, [])

  useEffect(() => {
    if (teamId) {
      api.teams.get(teamId, t => setTeam(t))
    }
  }, [teamId])

  useEffect(() => {
    if (teamId) {
      setLoadingTrials(true)
      api.teams.getTrials(
        teamId,
        { includeArchived: listTrialsIncludeArchived },
        res => { setTrials(res.trials); setLoadingTrials(false) },
        err => {
          setLoadingTrials(false)
          utils.toast('error', 'Failed to load trials', err?.message)
        })
    }
  }, [teamId, listTrialsIncludeArchived, setTrials, setLoadingTrials])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  if (loadingUser) {
    return (
      <EntryContainer asLoader />
    )
  }

  if (mfaEnrolRequired) {
    return (
      <>
        <GlobalStyle />
        <SetupMfa />
        <Toaster />
      </>
    )
  }

  return (
    <>
      <GlobalStyle />
      <Box display='flex' flexDirection='column' bg='bg.canvas' style={{ minHeight: '100vh' }}>
        {(user || team) &&
          <NavBar />}
        <Box flex={1}>
          <Outlet />
          <Toaster />
        </Box>
        <Footer />
      </Box>
    </>
  )
}
